{
  "alert_examples": {
    "camera_offline": "The Samarqand camera has been down for 25 minutes.",
    "cancelled_spike": "The share of people turning back is twice the usual.",
    "early_close": "The store closed 15 minutes before the schedule.",
    "flow_drop": "Riviera is 35% below the average of the last 4 Thursdays until 14:00.",
    "late_open": "City Mall opened at 10:24 today (usually 10:00).",
    "no_data": "No data from the Samarqand camera for 30 minutes.",
    "record": "Riviera: most visits in 90 days (318).",
    "target_progress": "82% of the monthly target reached, 5 days left."
  },
  "alert_kinds": {
    "agent_alert": "Server warning",
    "camera_offline": "Camera offline",
    "cancelled_spike": "More people turning back",
    "control_summary": "Store control: hourly summary",
    "customer_unattended": "Customers left unattended",
    "store_no_staff": "No staff in store",
    "disk_pressure": "Disk filling up",
    "early_close": "Early closing",
    "flow_drop": "Sharp drop in traffic",
    "late_open": "Late opening",
    "long_wait": "Customer waiting too long",
    "no_data": "No data",
    "post_empty": "Post left empty",
    "record": "Record",
    "release_failed": "Settings release failed",
    "report_not_sent": "Report not sent",
    "scheduled_task_failed": "Scheduled task failed",
    "security": "Security event",
    "server_offline": "Server offline",
    "staff_gathering": "Staff gathered together",
    "staff_phone": "Staff member on the phone",
    "target_progress": "Target"
  },
  "alert_severities": {
    "critical": "Critical",
    "info": "Info",
    "warning": "Warning"
  },
  "alerts": {
    "bell_label": "Alerts: {{count}} unread",
    "channel_destination": "Sent to: {{destination}}",
    "channel_telegram": "Telegram",
    "channel_unavailable_company_not_active": "Starts once the company is active",
    "channel_unavailable_telegram_not_linked": "The company's Telegram group is not linked yet — ask the platform administrator",
    "description": "Alert history and which alerts go to the Telegram group",
    "empty": "No alerts",
    "empty_unread": "No unread alerts",
    "example_label": "Example",
    "eyebrow": "ALERTS",
    "filter_all": "All",
    "filter_label": "Filter",
    "filter_unread": "Unread",
    "history_title": "History",
    "mark_all_read": "Mark all as read",
    "mark_all_read_done": "All alerts marked as read",
    "mark_read": "Mark as read",
    "open_store": "Open store",
    "preferences_saved": "Preferences saved",
    "preferences_title": "Send to the Telegram group",
    "preferences_unavailable": "Cannot be set until the group is linked",
    "preferences_unchanged": "No changes yet — switch something to save",
    "read_leave_list": "Read alerts leave the list 24 hours after reading",
    "rule": "Alert type",
    "see_all": "See all",
    "unread": "Unread"
  },
  "api_errors": {
    "breach_check_unavailable": "The password cannot be checked right now. Please try again later.",
    "captcha_required": "Please complete the check to continue.",
    "company_not_active": "The company is not activated yet. The panel opens once a super-admin activates the company.",
    "conflict": "The data has changed or already exists.",
    "csrf_failed": "The request could not be verified. Please reload the page.",
    "export_failed": "The file could not be prepared.",
    "export_not_ready": "The file is not ready yet.",
    "forbidden": "You do not have access to this section or action.",
    "hour_grain_too_long": "Hourly detail is available for periods of up to 62 days. Choose a shorter period.",
    "internal_error": "Internal error. Please try again shortly.",
    "invalid_credentials": "Incorrect login or password.",
    "network_error": "Cannot reach the server. Check your connection.",
    "not_found": "Not found or not accessible.",
    "password_breached": "This password appears in a list of leaked passwords. Choose another one.",
    "password_change_required": "Change your password to continue.",
    "password_reset_code_invalid": "The code is wrong or has expired. Request a new code.",
    "password_too_long": "The password is too long.",
    "password_too_short": "The password must be at least 12 characters long.",
    "pdf_renderer_unavailable": "PDF is not available right now. Choose Excel or CSV.",
    "rate_limited": "Too many attempts. Please try again later.",
    "session_expired": "Your session has expired. Please sign in again.",
    "session_network_changed": "Your network changed. Please sign in again for security.",
    "telegram_bot_unavailable": "The Telegram bot is not set up yet. Contact the platform administrator.",
    "too_many_points": "Too much data for the selected period. Choose a shorter period or fewer stores.",
    "unauthenticated": "Please sign in again.",
    "validation_failed": "The entered data is not valid.",
    "wrong_old_password": "The current password is incorrect."
  },
  "blocks": {
    "average_day_description": "Average day · {{range}}",
    "hourly_flow_metric": "Hourly flow metric",
    "hourly_flow_title": "Hourly flow",
    "hourly_period_too_long_text": "For example, choose the last 30 days",
    "hourly_period_too_long_title": "Hourly flow covers up to 62 days",
    "hourly_series_unique": "Unique",
    "hourly_series_visits": "All entries"
  },
  "brand": {
    "product_name": "Koz.uz"
  },
  "chart": {
    "axis_not_from_zero": "Axis does not start at 0",
    "other": "Other"
  },
  "common": {
    "cancel": "Cancel",
    "copied": "Copied",
    "copy": "Copy",
    "delete": "Delete",
    "save": "Save"
  },
  "comparison": {
    "best": "Best result",
    "eyebrow": "STORE COMPARISON",
    "metric": "Metric",
    "metrics": {
      "cancelled": "Turned back at the door",
      "children": "Children",
      "returning_share": "Returning share, %",
      "unique": "Unique visitors",
      "visits": "Visits (all entries)",
      "visits_per_hour": "Visits per hour",
      "work_hours": "Working hours"
    },
    "missing_range": "No data for {{range}}",
    "missing_short": "No data to compare",
    "mode_label": "Comparison mode",
    "mode_network": "Store vs network average",
    "mode_stores": "Stores",
    "network_average": "Network average",
    "network_index": "Network average shown as 100",
    "partial_day": "The comparison period has incomplete data ({{compare}} of {{current}} days)",
    "partial_hour": "The comparison period has incomplete data ({{compare}} of {{current}} hours)",
    "partial_store": "The comparison day has incomplete data ({{compare}} of {{current}} stores)",
    "period_vs_period": "Current vs comparison period",
    "pick_more_stores": "Select at least {{count}} stores to compare",
    "title": "Compare stores",
    "view_indexed": "Index",
    "view_label": "View",
    "view_line": "Lines",
    "view_small_multiples": "Small multiples",
    "view_table": "Table",
    "view_weekday": "Weekdays",
    "weekday_title": "{{metric}} · average per day",
    "vs_range": "vs {{range}}",
    "data_from_range": "{{range}} (data from {{date}})",
    "point_no_data": "no data",
    "missing_days_legend": "{{range}} · no data on {{count}} days",
    "partial_coverage": "Incomplete data: some hours have no data (coverage: current period {{current}}, comparison period {{compare}})",
    "point_incomplete": "⚠ incomplete",
    "part_incomplete": "Incomplete data: some hours of this part of the day have no data or an outage"
  },
  "dashboard": {
    "daypart_afternoon": "Afternoon",
    "daypart_evening": "Evening",
    "daypart_lunch": "Lunch",
    "daypart_morning": "Morning",
    "dayparts_average_description": "Average day · {{range}}",
    "dayparts_compare_label": "Compare with",
    "dayparts_last_week": "Same day last week",
    "dayparts_title": "Dayparts",
    "dayparts_yesterday": "Yesterday",
    "description": "Live flow and the key numbers of your stores",
    "eyebrow": "NETWORK VIEW · {{date}}",
    "full_ranking": "Full ranking",
    "insights_day": "Yesterday's results · {{date}}",
    "no_region": "No region",
    "performance_title": "Store performance",
    "ranking_title": "Store ranking",
    "region_summary_unique": "{{stores}} stores · {{value}} unique visitors",
    "region_summary_visits": "{{stores}} stores · {{value}} visits",
    "store_tile_label_unique": "{{store}}: {{value}} unique visitors, {{change}}",
    "store_tile_label_visits": "{{store}}: {{value}} visits, {{change}}",
    "title": "Dashboard"
  },
  "doors": {
    "title": "Entrances",
    "total_label": "Store total",
    "total_caption": "Through {{doors}} doors",
    "column_door": "Door",
    "column_visits": "Visits",
    "column_share": "Share",
    "column_coverage": "Coverage",
    "share_bar": "Door shares",
    "state_partial": "Partly down",
    "state_none": "No data",
    "partial_title": "{{down}} of {{total}} doors were down",
    "none_title": "No door was counted",
    "outage_interval": "{{door}}: {{from}}–{{to}}",
    "outage_since": "{{door}}: since {{since}}",
    "note_interval": "down {{from}}–{{to}}",
    "note_since": "down since {{since}}",
    "note_more": "{{note}} · {{count}} more",
    "tile_partial": "Partly down: {{details}}",
    "tile_label_partial": "{{label}}, partly down"
  },
  "errors": {
    "go_home": "Go to dashboard",
    "not_found_text": "The link is outdated or you have no access to this section.",
    "not_found_title": "Page not found",
    "save_failed": "Could not save. Please try again."
  },
  "exports": {
    "delete_after_ready": "Once the file is ready you can download or delete it",
    "delete_description": "“{{name}}” will be removed from the list and from the server. You can generate the report again if needed.",
    "delete_failed": "Could not delete the file. Please try again.",
    "delete_named": "Delete file “{{name}}”",
    "delete_title": "Delete this file?",
    "dismiss": "Remove from list",
    "download": "Download",
    "failed_hint": "Generate the report again",
    "failed_title": "Export failed",
    "file_kept_until": "File kept until {{time}} (removed once downloaded)",
    "jobs_description": "A file is removed once downloaded, or after 24 hours",
    "jobs_title": "Exports",
    "kind_csv": "CSV (UTF-8)",
    "kind_pdf": "PDF",
    "kind_xlsx": "Excel (.xlsx)",
    "link_valid_until": "Link valid until {{time}}",
    "list_failed": "Could not load the exports list",
    "no_jobs": "No exports yet",
    "no_jobs_hint": "When you generate a report, the file appears here",
    "ready_title": "File is ready",
    "report_control_events": "Control events",
    "report_custom": "Custom report",
    "report_daily": "Daily report",
    "report_monthly": "Monthly report",
    "report_screen": "Page export",
    "report_weekly": "Weekly report",
    "report_yearly": "Yearly report",
    "started_title": "Export started",
    "status_done": "Ready",
    "status_failed": "Failed",
    "status_queued": "Queued",
    "status_running": "Preparing"
  },
  "filters": {
    "all_stores": "All stores",
    "stores": "Stores"
  },
  "forgot_password": {
    "back_to_login": "Back to sign-in",
    "code": "6-digit code from Telegram",
    "code_sent": "If Telegram is connected, the code was sent",
    "description": "We send a code to your Telegram",
    "done_text": "Password saved, other sessions ended",
    "done_title": "Password changed",
    "error_code_invalid": "The code is wrong or has expired. Request a new code.",
    "go_to_login": "Sign in",
    "no_telegram_hint": "No Telegram? Ask your administrator",
    "request_again": "No code? Request again",
    "save_password": "Save the new password",
    "send_code": "Send code",
    "title": "Reset password"
  },
  "holidays": {
    "constitution_day": "Constitution Day",
    "eid_al_adha": "Eid al-Adha",
    "eid_al_fitr": "Eid al-Fitr",
    "independence_day": "Independence Day",
    "navruz": "Navruz",
    "new_year": "New Year",
    "ramadan_start": "Start of Ramadan",
    "remembrance_day": "Day of Remembrance and Honour",
    "teachers_day": "Teachers' Day",
    "womens_day": "International Women's Day"
  },
  "kpi": {
    "average_work_hours": "Average working time",
    "busiest_hour": "Busiest hour",
    "busiest_hour_average_note_unique": "on average {{value}} unique visitors",
    "busiest_hour_average_note_visits": "on average {{value}} visits",
    "busiest_hour_compare": "{{range}}: {{hour}}",
    "busiest_hour_note_unique": "{{value}} unique visitors",
    "busiest_hour_note_visits": "{{value}} visits",
    "per_store_day": "per store per day"
  },
  "languages": {
    "en": "English",
    "ru": "Русский",
    "uz": "O'zbekcha"
  },
  "live": {
    "last_hour": "Visits in the last hour",
    "last_hour_unique": "Unique in the last hour",
    "status_connecting": "connecting",
    "status_open": "connected",
    "status_reconnecting": "reconnecting",
    "title": "Live counter",
    "today_entries": "Visits (live)",
    "today_unique": "Unique (live)",
    "updated_at": "Updated"
  },
  "login": {
    "error_invalid": "Incorrect login or password",
    "error_network": "Cannot reach the server. Check your connection.",
    "error_rate_limited": "Too many attempts. Please try again later.",
    "forgot_link": "Forgot your password?",
    "login": "Login",
    "password": "Password",
    "submit": "Sign in",
    "submitting": "Signing in…",
    "subtitle": "Sign in to your company account.",
    "title": "Sign in"
  },
  "metric_definitions": {
    "average_work_hours": "How many hours one store is open on an average day.",
    "busiest_hour": "The hour with the most visits in the selected period.",
    "cancelled": "Entered and left within 120 seconds (not part of visits).",
    "children": "Entries recognised as children (not part of visits).",
    "coverage": "How much of the trading time the cameras were working. 100% means the whole time was counted.",
    "returning": "Visits recognised as returning on the same day.",
    "staff": "Entries recognised as staff.",
    "unique": "The main number: how many different people came during the day. Someone who returns the same day is counted once.",
    "visits": "Every entry into the store: someone who enters twice in a day is counted twice. Staff, children and people who left right away are not counted.",
    "visits_per_hour": "How many visits the store gets on average in each opening hour.",
    "work_hours": "How long the store was open (by its door or its schedule)."
  },
  "metrics": {
    "cancelled": "Turned back at the door",
    "children": "Children",
    "coverage": "Coverage",
    "returning": "Returning",
    "staff": "Staff entries",
    "unique": "Unique visitors",
    "visits": "Visits (all entries)",
    "visits_per_hour": "Visits per hour",
    "work_hours": "Working hours"
  },
  "months": {
    "apr": "Apr",
    "aug": "Aug",
    "dec": "Dec",
    "feb": "Feb",
    "jan": "Jan",
    "jul": "Jul",
    "jun": "Jun",
    "mar": "Mar",
    "may": "May",
    "nov": "Nov",
    "oct": "Oct",
    "sep": "Sep"
  },
  "nav": {
    "alerts": "Alerts",
    "comparison": "Comparison",
    "dashboard": "Dashboard",
    "group_account": "Account",
    "group_analytics": "Analytics",
    "group_marketing": "Marketing",
    "group_operations": "Operations",
    "marketing_ads": "Advertising",
    "marketing_automation": "Automation",
    "marketing_campaigns": "Campaigns",
    "marketing_chats": "Chats",
    "marketing_contacts": "Contacts",
    "marketing_connections": "Connections",
    "marketing_content": "Content",
    "marketing_overview": "Result",
    "marketing_report": "Report",
    "marketing_sales": "Sales",
    "metrics": "Metrics",
    "quality": "Data quality",
    "ranking": "Ranking",
    "reports": "Reports",
    "settings": "Settings",
    "store_control": "Store control",
    "stores": "Stores",
    "trading_hours": "Trading hours",
    "trends": "Trends"
  },
  "password": {
    "confirm": "Repeat the new password",
    "error_mismatch": "Passwords do not match",
    "error_password_breached": "This password appears in a list of leaked passwords",
    "error_password_reused": "The new password must differ from the old one",
    "error_password_too_short": "Password is too short",
    "error_unknown": "Could not change the password",
    "error_wrong_old_password": "Current password is incorrect",
    "forced_text": "Replace the temporary password with your own",
    "forced_title": "Set a new password",
    "new": "New password",
    "old": "Current password",
    "rules": "At least {{count}} characters, not reused elsewhere",
    "save": "Save password",
    "saving": "Saving…"
  },
  "quality": {
    "average_coverage": "Average coverage",
    "camera_offline": "offline",
    "camera_online": "online",
    "coverage": "Coverage",
    "description": "Camera status, outages and daily coverage",
    "eyebrow": "DEVICE HEALTH",
    "outage_kind_camera": "camera",
    "outage_kind_pipeline": "counting software",
    "outage_kind_system": "server",
    "outage_ongoing": "ongoing",
    "outage_summary": "{{count}} outages · {{minutes}} min",
    "outages": "Outages",
    "title": "Data quality",
    "outage_summary_one": "{{count}} outage · {{minutes}} min",
    "outage_compact": "{{count}} · {{minutes}} min",
    "outage_minutes": "{{minutes}} min",
    "outage_burst": "{{count}} outages",
    "outage_details": "Details",
    "outage_total_minutes": "Total time",
    "no_data": "No data",
    "outage_count": "{{count}} outages",
    "outage_count_one": "{{count}} outage",
    "legend_good": "≥ 99%",
    "legend_warn": "95–99%",
    "legend_bad": "< 95%",
    "legend_empty": "No data",
    "granularity": "Step",
    "granularity_day": "Day",
    "granularity_week": "Week",
    "granularity_month": "Month",
    "outages_empty": "No outages",
    "page_summary": "{{from}}–{{to}} of {{total}}",
    "page_previous": "Previous page",
    "page_next": "Next page",
    "summary_aria": "Period at a glance",
    "summary_coverage_hint_one": "across {{count}} store",
    "summary_coverage_hint_other": "across {{count}} stores",
    "coverage_info": "Coverage is the share of the store's opening hours during which the cameras and the server were working. An outage is time when a camera or the server was down: visitors in those minutes are not counted, so that day's numbers may be lower than reality. Outages shorter than a minute barely affect the numbers.",
    "summary_significant_days": "Days that matter",
    "summary_significant_hint_one": "in {{count}} store",
    "summary_significant_hint_other": "in {{count}} stores",
    "summary_long_outages": "Long outages",
    "summary_long_hint": "longer than 5 minutes",
    "summary_lost_time": "Time lost",
    "summary_lost_hint": "while the store was open",
    "summary_cameras": "Cameras online",
    "summary_cameras_all_online": "All working",
    "summary_cameras_offline": "Offline: {{names}}",
    "significant_rule": "Only days that matter: coverage below 99.5% or an outage longer than 5 minutes",
    "show_minor": "All outages ({{count}} minor)",
    "sort": "Order",
    "sort_worst": "Worst first",
    "sort_date": "By date",
    "view": "View",
    "view_list": "List",
    "view_calendar": "Calendar",
    "group_badge_days_one": "{{count}} day",
    "group_badge_days_other": "{{count}} days",
    "group_summary_worst": "worst {{date}} · {{coverage}}",
    "group_summary_lost": "{{duration}} in total",
    "group_summary_long": "{{count}} long",
    "group_summary_minor_only": "minor outages only",
    "duration_hours": "{{hours}} h {{minutes}} min",
    "no_significant": "No outages that matter in this period",
    "no_significant_hint": "Days with minor outages hidden: {{count}}",
    "quiet_stores": "No outages that matter: {{stores}}",
    "minor_badge": "minor",
    "day_longest": "longest {{minutes}}",
    "calendar_aria": "Coverage calendar",
    "calendar_full": "Complete (≥ 99.5%)",
    "calendar_significant": "Outage that matters",
    "calendar_bad": "Coverage < 95%",
    "timeline_failed": "Timeline did not load",
    "duration_whole_hours": "{{hours}} h"
  },
  "ranking": {
    "change": "Change, %",
    "coverage": "Coverage",
    "eyebrow": "RANKING",
    "from": "From",
    "incomplete_badge": "⚠ incomplete",
    "incomplete_description": "Stores with coverage below 95% are listed separately.",
    "incomplete_title": "Incomplete data",
    "index": "Index",
    "league_table": "League table",
    "metric": "Metric",
    "no_movers": "None in this period",
    "per_hour_hint": "To compare stores with different working hours fairly, choose “Visits per hour”",
    "period": "Period",
    "periods": {
      "custom": "Custom",
      "day": "Day",
      "month": "Month",
      "quarter": "Quarter",
      "week": "Week",
      "year": "Year"
    },
    "previous": "Previous period",
    "range_caption": "{{current}} · compared with {{previous}}",
    "rank": "Rank",
    "rank_change": "Change",
    "store": "Store",
    "title": "Store ranking",
    "to": "To",
    "top_drop": "Largest drop",
    "top_growth": "Top growth"
  },
  "reports": {
    "choose_month": "Choose a month",
    "choose_week": "Choose a week",
    "choose_year": "Choose a year",
    "custom_title": "Custom report",
    "daily_range_too_long": "At most {{days}} days",
    "description": "Excel, CSV and PDF are prepared in the background",
    "eyebrow": "REPORTS",
    "field_daily": "Day or range",
    "field_monthly": "Month",
    "field_weekly": "Week",
    "field_yearly": "Year",
    "format": "Format",
    "grain": "Granularity",
    "grain_day": "Day",
    "grain_hour": "Hour",
    "grain_month": "Month",
    "grain_week": "Week",
    "kind_daily": "Daily",
    "kind_daily_contents": "Per store: key numbers, opening hours, by hour",
    "kind_daily_schedule": "Automatic: after the trading day",
    "kind_monthly": "Monthly",
    "kind_monthly_contents": "By day, weekday, ranking, last year",
    "kind_monthly_schedule": "Automatic: the 1st of each month",
    "kind_weekly": "Weekly",
    "kind_weekly_contents": "By day, ranking, last week and year",
    "kind_weekly_schedule": "Automatic: Monday 09:00",
    "kind_yearly": "Yearly",
    "kind_yearly_contents": "By month, ranking, last year, holidays",
    "kind_yearly_schedule": "On request",
    "metrics": "Metrics",
    "ready_title": "Ready reports",
    "run": "Generate",
    "save_template": "Save as template",
    "template_all_stores": "All stores",
    "template_already_editing": "This template is already open in the form above",
    "template_cancel_edit": "Cancel",
    "template_delete_description": "Template “{{name}}” will be deleted. Files already created from it stay.",
    "template_delete_failed": "Could not delete the template. Please try again.",
    "template_delete_title": "Delete this template?",
    "template_edit": "Edit",
    "template_editing": "Editing template “{{name}}”: make your changes and press “Save changes”",
    "template_editing_badge": "Being edited",
    "template_more_actions": "More actions for “{{name}}”",
    "template_name": "Template name",
    "template_need_metric": "Choose at least one metric",
    "template_need_name": "Type a template name to save it",
    "template_no_permission": "Saving templates needs the “Reports and alerts” permission. Ask your company administrator.",
    "template_rename": "Rename",
    "template_rename_description": "Type a new name for “{{name}}”",
    "template_rename_title": "Rename template",
    "template_save_changes": "Save changes",
    "template_save_failed": "Could not save the template. Please try again.",
    "template_store_count": "{{count}} stores",
    "templates_empty": "No templates",
    "templates_empty_hint": "Choose the settings above, type a name and press “Save as template”",
    "templates_title": "Saved templates",
    "title": "Reports and exports",
    "week_number_short": "Wk",
    "week_title": "Week {{week}}, {{year}}"
  },
  "server_messages": {
    "alert": {
      "camera_offline": "{{store}}: camera {{camera}} has not been working for {{minutes}} minutes.",
      "cancelled_spike": "{{store}}: people turning back at the door {{ratio}}× more often than usual.",
      "control_summary": "{{store}}: {{total}} alerts from {{hour_start}}–{{hour_end}} were not sent one by one because the hourly limit was reached.",
      "customer_unattended": "{{store}}, {{camera}}: {{customer_count}} customers without staff since {{started_time}}, {{minutes}} min.",
      "store_no_staff": "{{store}}: no staff seen on any of the store's cameras since {{started_time}}, {{minutes}} min.",
      "early_close": "{{store}} closed at {{closed_at}} (planned {{planned_at}}).",
      "flow_drop": "{{store}}: visits until {{until_hour}}:00 are {{drop_pct}} below the average of the last {{weeks}} same weekdays.",
      "late_open": "{{store}} opened at {{opened_at}} (usually {{planned_at}}).",
      "long_wait": "{{store}}, {{camera}}: a customer has been waiting for service since {{started_time}}, {{minutes}} min.",
      "no_data": "{{store}}: no data for {{minutes}} minutes during trading hours.",
      "post_empty": "{{store}}, {{camera}}: the post has had no staff since {{started_time}}, {{minutes}} min.",
      "record": "{{store}}: the most visits in {{window_days}} days ({{visits}}).",
      "staff_gathering": "{{store}}, {{camera}}: {{staff_count}} staff standing together since {{started_time}}, {{minutes}} min.",
      "staff_phone": "{{store}}, {{camera}}: a staff member has been on the phone since {{started_time}}, {{minutes}} min.",
      "target_progress": "{{store}}: {{progress_pct}} of the monthly target reached, {{days_left}} days left."
    },
    "insight": {
      "alert": {
        "title": "Attention"
      },
      "leader": {
        "text": "{{store}}: {{unique}} unique visitors ({{visits}} entries).",
        "title": "Leader"
      },
      "network_change": {
        "text": "{{unique}} unique visitors · {{change_pct}}",
        "title": "Network vs last week"
      },
      "weakest": {
        "text": "{{store}}: unique visitors {{change_pct}} vs last week.",
        "title": "Weakest"
      }
    }
  },
  "section_locked": {
    "title": "The “{{section}}” section is not available to you",
    "title_generic": "This section is not available to you",
    "reason_single_store": "Comparison and ranking need at least two stores, and you have one store assigned.",
    "reason_company_admin_decides": "Your company administrator decides which sections you can see. Ask them if you need this one.",
    "reason_not_in_company_plan": "This section is not enabled for your company. Contact Koz.uz to turn it on.",
    "back": "Back to the dashboard"
  },
  "settings": {
    "api_key_created": "Created",
    "api_key_last_used": "Last used",
    "api_key_name": "Name",
    "api_key_name_required": "Enter a key name to create it",
    "api_key_never_used": "Not used yet",
    "api_key_prefix": "Key",
    "api_key_revoke": "Revoke key {{name}}",
    "api_key_revoke_confirm": "Revoke",
    "api_key_revoke_text": "Integrations using this key stop working immediately.",
    "api_key_revoke_title": "Revoke key",
    "api_key_revoked_toast": "Key revoked",
    "api_key_secret_text": "The key is shown only now. Store it somewhere safe.",
    "api_key_secret_title": "New API key",
    "api_key_stores_hint": "With no store chosen, the key sees every store",
    "api_keys_description": "For other programs (for example Power BI or Excel) that fetch the data themselves. A key can only read, and sees only the chosen stores.",
    "api_keys_title": "API keys",
    "appearance_description": "Saved in this browser only",
    "appearance_title": "Language",
    "branding_color": "Company colour",
    "branding_color_code": "Colour code",
    "branding_color_description": "Colour of buttons and accents",
    "branding_color_error_contrast": "The colour is too light for readable text. Choose a darker one.",
    "branding_color_error_format": "Enter it as #RRGGBB.",
    "branding_color_hint": "Very light colours are not allowed: white text on buttons must stay readable",
    "branding_color_reset": "Back to the platform colour",
    "branding_color_save": "Save colour",
    "branding_color_saved": "Colour saved",
    "branding_color_unchanged": "The colour has not changed",
    "branding_description": "The logo appears in the panel header, the browser tab and the PDF/Excel reports.",
    "branding_logo_card_description": "Shown in the panel header, browser tab and reports",
    "branding_logo_card_info": "After choosing a file you crop it as a square or a circle.",
    "branding_logo_error_file_too_large": "The file is larger than 2 MB.",
    "branding_logo_error_svg_not_allowed": "SVG files are not accepted — choose a PNG or JPG.",
    "branding_logo_error_unsupported_type": "Only PNG or JPG files.",
    "branding_logo_light": "Company logo",
    "branding_logo_light_hint": "Used in both the light and the dark theme",
    "branding_logo_none": "No logo — the platform logo is shown",
    "branding_logo_remove": "Remove",
    "branding_logo_removed": "Logo removed",
    "branding_logo_rules": "PNG or JPG, up to 2 MB",
    "branding_logo_saved": "Logo saved",
    "branding_logo_title": "Logo",
    "branding_logo_upload": "Upload logo",
    "branding_read_only": "The company administrator changes the logo and colour",
    "branding_shape_circle": "Shape: circle",
    "branding_shape_square": "Shape: square",
    "branding_title": "Company branding",
    "create_api_key": "Create key",
    "create_user": "Create",
    "error_login_invalid": "Login: lowercase Latin letters, digits and . _ - only (at least 3)",
    "error_login_taken": "This login is taken",
    "eyebrow": "ACCOUNT",
    "initial_password_text": "The password for {{login}} is shown only now. It must be changed at first sign-in.",
    "initial_password_title": "Initial password",
    "language_label": "Language",
    "name_required": "Enter a name",
    "new_api_key": "New API key",
    "new_password_title": "New password",
    "new_store_user": "New store user",
    "no_api_keys": "No keys",
    "no_store_users": "No users",
    "password_changed": "Password changed",
    "password_description": "Your other devices will be signed out",
    "password_save_needs": "Enter the current password and the new one twice",
    "password_title": "Password",
    "profile_company": "Company",
    "profile_description": "Your name is shown in the panel and in the change history",
    "profile_login_hint": "The login cannot be changed",
    "profile_role": "Role",
    "profile_saved": "Name saved",
    "profile_scope_hint": "An administrator sets the role and the stores",
    "profile_title": "Account",
    "profile_unchanged": "The name has not changed",
    "role_company_admin": "Company administrator",
    "role_store_user": "Store user",
    "store_users_title": "Store users",
    "tab_api_keys": "API keys",
    "tab_preferences": "Appearance",
    "tab_profile": "Profile",
    "tab_security": "Security",
    "tab_store_users": "Store users",
    "telegram_bot_unavailable": "The Telegram bot is not set up yet — contact the administrator",
    "telegram_connect": "Connect Telegram",
    "telegram_connected": "Connected",
    "telegram_connected_toast": "Telegram connected",
    "telegram_description": "Password reset codes come here",
    "telegram_disconnect": "Disconnect",
    "telegram_disconnect_text": "After disconnecting, password reset codes are no longer sent to Telegram.",
    "telegram_disconnect_title": "Disconnect Telegram?",
    "telegram_disconnected_toast": "Telegram disconnected",
    "telegram_linked_at": "since {{date}}",
    "telegram_loading": "Loading…",
    "telegram_not_connected": "Telegram is not connected yet",
    "telegram_open": "Open Telegram",
    "telegram_qr_label": "QR code that opens the Telegram bot",
    "telegram_step_open": "Scan the QR code or press the button",
    "telegram_step_start": "Press “Start” in the bot.",
    "telegram_title": "Telegram",
    "telegram_waiting": "Waiting for confirmation · {{minutes}} min",
    "user_actions": "Actions",
    "user_actions_for": "Actions for {{login}}",
    "user_active": "active",
    "user_block": "Block",
    "user_block_text": "{{login}} cannot sign in, and open sessions end at once. You can unblock later.",
    "user_block_title": "Block this user?",
    "user_blocked": "blocked",
    "user_blocked_toast": "User blocked",
    "user_create_needs": "Enter a login and a name to create the user",
    "user_edit": "Edit",
    "user_edit_description": "Login: {{login}}. The login cannot be changed.",
    "user_edit_title": "Edit user",
    "user_last_login": "Last sign-in",
    "user_login": "Login",
    "user_login_hint": "3–64 characters: lowercase Latin letters, digits, dot, _ or -",
    "user_name": "Name",
    "user_never_signed_in": "Never signed in",
    "user_remove": "Remove",
    "user_remove_text": "{{login}} leaves the list and can never sign in again. The login cannot be reused.",
    "user_remove_title": "Remove this user?",
    "user_removed_toast": "User removed",
    "user_reset_confirm": "Issue password",
    "user_reset_password": "Issue a new password",
    "user_reset_text": "{{login}} can no longer sign in with the old password and is signed out everywhere. The new password is shown once.",
    "user_reset_title": "Issue a new password?",
    "user_saved": "Changes saved",
    "user_status": "Status",
    "user_stores": "Stores",
    "user_stores_hint": "With no store chosen, the user gets every store",
    "user_unblock": "Unblock",
    "user_unblocked_toast": "User unblocked"
  },
  "shell": {
    "company_eyebrow": "{{company}} · client panel"
  },
  "store": {
    "busiest_hours_title": "Busiest hours",
    "calendar_title": "Daily calendar",
    "composition_not_visits": "Not counted as visits:",
    "composition_title": "Visit composition",
    "description": "Visits, opening hours and the busiest hours",
    "eyebrow": "STORE · {{region}}",
    "eyebrow_plain": "STORE",
    "hourly_table_title": "Hourly table",
    "hourly_total": "Total",
    "next_year": "Next year",
    "previous_year": "Previous year",
    "switch_store": "Choose store",
    "trading_hours_door": "Opening and closing measured from the shutter.",
    "trading_hours_manual": "Trading hours follow the schedule.",
    "trading_hours_title": "Trading hours",
    "weekday_heatmap_title": "Weekdays and hours",
    "busiest_hour_mark": "busiest"
  },
  "store_targets": {
    "title": "Monthly targets",
    "description_editor": "Visit target for each month. The platform administrator also sees and can change these targets.",
    "description_reader": "Visit target for each month. Targets are set by the company administrator.",
    "list_label": "Monthly targets list",
    "empty_title": "No targets set yet",
    "empty_editor_text": "Enter a month and the number of visits below.",
    "empty_reader_text": "Targets are set by the company administrator.",
    "load_failed": "Could not load the targets",
    "visits_value": "{{visits}} visits",
    "current_month": "Current month",
    "changed_by": "Changed by {{who}}, {{when}}",
    "changed_at": "Changed {{when}}",
    "platform_editor": "{{name}} (platform administrator)",
    "progress": "So far {{done}} / {{target}} · {{percent}}",
    "progress_label": "Progress of the current month's target",
    "month": "Month",
    "visits": "Visit target",
    "visits_hint": "Whole number from 0 to 100,000,000",
    "save": "Save",
    "update": "Update",
    "edit": "Edit",
    "edit_month": "Edit the {{month}} target",
    "delete": "Delete",
    "delete_month": "Delete the {{month}} target",
    "delete_title": "Delete target",
    "delete_text": "The {{month}} target of {{visits}} visits will be deleted.",
    "saved": "Target saved",
    "updated": "Target updated",
    "deleted": "Target deleted"
  },
  "table": {
    "date": "Date",
    "hour": "Hour",
    "store": "Store"
  },
  "trading_hours": {
    "actual_vs_plan": "{{actual}} (plan {{plan}})",
    "average_close": "Average closing",
    "average_open": "Average opening",
    "chart_off_plan": "Opened late / closed early",
    "chart_plan": "Schedule",
    "chart_range": "Opened–closed",
    "closed": "Closed",
    "closed_today": "Closed today",
    "day_incomplete": "incomplete: closing not recorded",
    "day_no_data": "no data",
    "day_still_open": "not closed yet",
    "description": "Opening, closing and deviation from the schedule",
    "deviation": "Deviation",
    "early_by": "closed {{minutes}} min early",
    "events_description": "Only stores with a shutter camera",
    "events_title": "Late openings / early closings",
    "eyebrow": "TRADING HOURS",
    "hours": "Worked",
    "late_by": "opened {{minutes}} min late",
    "late_days": "Days opened late",
    "late_days_value": "{{late}} of {{total}} days",
    "no_events": "No delays in this period",
    "no_off_hours": "None in this period",
    "not_opened_yet": "not opened yet",
    "off_hours_title": "Openings while closed",
    "on_time": "on time",
    "opened": "Opened",
    "opened_today": "Opened today",
    "per_schedule": "per schedule",
    "plan": "Schedule",
    "planned_close": "Planned closing",
    "planned_open": "Planned opening",
    "source": "Source",
    "source_door": "Shutter",
    "source_manual": "Schedule",
    "source_planned": "Planned",
    "status": "Status",
    "table_title": "Daily trading hours",
    "title": "Trading hours",
    "tooltip_closed": "Closed {{time}}",
    "tooltip_open_for": "Open {{hours}} h {{minutes}} min",
    "tooltip_opened": "Opened {{time}}",
    "tooltip_plan": "Schedule {{range}}",
    "source_schedule_fallback": "No shutter data — per schedule",
    "source_shutter_missing": "No shutter data",
    "not_measured": "per schedule, not measured",
    "not_measured_hint": "The shutter camera sent no data at this time while customers came in: opening and closing are taken from the schedule (not measured).",
    "shutter_missing_hint": "The shutter camera sent no data and there is no schedule: the day was counted with an unknown session.",
    "csv_not_measured_suffix": " (per schedule, not measured)",
    "tooltip_schedule_fallback": "No shutter data — times per schedule"
  },
  "trends": {
    "daily_title": "{{metric}}: daily",
    "description": "Are unique visitors growing or falling week to week",
    "eyebrow": "TRENDS",
    "flag_recomputed": "Recomputed",
    "flag_settings_change": "Settings changed",
    "metric": "Metric",
    "moving_average": "{{days}}-day average",
    "promo_add": "Add promotion",
    "promo_after": "After",
    "promo_before": "Before",
    "promo_daily_average_unique": "Daily average, unique visitors",
    "promo_daily_average_visits": "Daily average, visits",
    "promo_delete": "Delete promotion {{name}}",
    "promo_delete_text": "The promotion \"{{name}}\" will be removed from the calendar.",
    "promo_delete_title": "Delete promotion",
    "promo_during": "During the promotion",
    "promo_empty": "No promotions yet",
    "promo_from": "From",
    "promo_list": "Promotions",
    "promo_name": "Promotion name",
    "promo_not_yet": "not finished yet",
    "promo_title": "Promotions",
    "promo_to": "To",
    "promo_vs_before": "vs before",
    "promo_window": "Window",
    "short_history_text": "Data since {{date}}; trends get reliable after 2 months",
    "short_history_title": "Not much history yet",
    "title": "Trends",
    "yoy_title": "By month: this year and last year",
    "ytd_caption": "{{year}}: {{value}}",
    "ytd_note": "vs the same period last year",
    "ytd_title": "{{metric}}: year to date"
  },
  "user_menu": {
    "connections": "Connections",
    "language": "Language",
    "logout": "Sign out",
    "open": "User menu: {{name}}",
    "theme": "Theme",
    "theme_dark": "Dark",
    "theme_light": "Light",
    "theme_system": "Auto"
  },
  "weekdays": {
    "fri": "Fri",
    "mon": "Mon",
    "sat": "Sat",
    "sun": "Sun",
    "thu": "Thu",
    "tue": "Tue",
    "wed": "Wed"
  },
  "table_search": {
    "stores": "Search stores…",
    "users": "Search users…"
  },
  "control": {
    "compare": {
      "column_events": "Events",
      "column_minutes": "Minutes",
      "column_rank": "Rank",
      "column_region": "Region",
      "column_store": "Store",
      "description": "Stores and regions against the network average",
      "group_regions": "Regions",
      "group_stores": "Stores",
      "grouping_label": "Grouping",
      "index": "Index",
      "index_definition": "Network average = 100. Below 100 is better",
      "metric_label": "Metric",
      "metrics": {
        "per_1000_visits": "Events per 1 000 visits",
        "per_work_hour": "Event minutes per work hour"
      },
      "network_average": "Network average",
      "no_region": "No region",
      "pick_more": "Pick at least 2 to compare",
      "ranking_title": "Ranking of all stores",
      "regions_label": "Regions",
      "regions_placeholder": "All regions",
      "search_stores": "Search stores…",
      "state_label": "State"
    },
    "duration": {
      "hours_minutes": "{{hours}} h {{minutes}} min",
      "minutes": "{{minutes}} min",
      "minutes_seconds": "{{minutes}} min {{seconds}} s",
      "seconds": "{{seconds}} s"
    },
    "events": {
      "all_states": "All states",
      "all_zones": "All zones",
      "description": "Every event with its frames",
      "empty": "No events match the filters",
      "export_excel": "Download Excel",
      "export_label": "Control events · {{range}}",
      "false_positive_badge": "Marked as false alarm",
      "filter_states": "States",
      "filter_zone": "Zone",
      "in_progress": "In progress",
      "list_title": "Event list",
      "load_more": "Load more",
      "open_event": "{{state}}, {{store}}, {{time}}",
      "staff_customers": "Staff: {{staff}} · Customers: {{customers}}",
      "total": "{{shown}} of {{total}}"
    },
    "eyebrow": "STORE CONTROL · {{date}}",
    "minutes": "{{value}} min",
    "open_now_badge": "Open now: {{count}}",
    "overview": {
      "all_events": "All events",
      "description": "Staff discipline and attention to customers",
      "empty": "No events in the selected period",
      "event_count": "{{formattedCount}} events",
      "event_count_one": "{{formattedCount}} event",
      "heatmap_title": "Events by hour and weekday",
      "mostly": "Mostly: {{state}}",
      "not_set_up": "Not set up",
      "worst_title": "5 most problematic stores"
    },
    "score": {
      "details": "Details",
      "formula": "Score = 100 × (1 − event minutes ÷ observed work minutes). Events marked as false alarms are not counted.",
      "grade_fair": "Fair",
      "grade_good": "Good",
      "grade_poor": "Poor",
      "no_data": "No data",
      "out_of": "/ 100",
      "title": "Control score"
    },
    "service": {
      "by_store_title": "By store",
      "chart_title": "Wait time",
      "customers": "Customers observed",
      "customers_definition": "Customers who entered service zones",
      "description": "How long customers wait for staff",
      "long_wait_line": "Long-wait threshold",
      "median": "Typical wait",
      "median_definition": "Half of customers waited less (median)",
      "not_set_up": "Service zones are not set up",
      "p90": "Long wait",
      "p90_definition": "90% of customers waited less (p90)",
      "unserved": "Left unserved",
      "unserved_definition": "Share of customers who left without a staff contact",
      "view_day": "Day",
      "view_hour": "Hour",
      "view_label": "Breakdown",
      "view_weekday": "Weekday"
    },
    "state_definitions": {
      "customer_unattended": "Customers present, no staff nearby",
      "store_no_staff": "No staff is seen on any of the store's cameras. All cameras are checked together; it never fires while a camera is offline.",
      "post_empty": "No staff at a cash desk or post",
      "service_wait": "A customer waited long for staff",
      "staff_gathering": "3 or more staff standing together",
      "staff_phone": "A staff member uses a phone for a long time"
    },
    "states": {
      "customer_unattended": "Customer unattended",
      "store_no_staff": "No staff in store",
      "post_empty": "Post left empty",
      "service_wait": "Long wait",
      "staff_gathering": "Staff gathering",
      "staff_phone": "Staff on the phone"
    },
    "store_block": {
      "by_zone": "By zone (today)",
      "details": "Details",
      "none_open": "Nothing open right now",
      "open_now": "Open now",
      "started_ago": "{{minutes}} min ago",
      "title": "Control",
      "today": "Today",
      "zone_open": "{{count}} open"
    },
    "tabs": {
      "compare": "Comparison",
      "events": "Events",
      "overview": "Overview",
      "service": "Service quality"
    },
    "tabs_label": "Store control sections",
    "title": "Store control",
    "viewer": {
      "camera": "Camera",
      "confirm_action": "Yes, false alarm",
      "confirm_text": "The event is removed from every metric",
      "confirm_title": "Mark this event as a false alarm?",
      "duration": "Duration",
      "ended": "Ended",
      "frame_alt": "{{state}}: frame {{current}}, {{time}}",
      "frame_counter": "Frame {{current}} of {{total}}",
      "frame_load_failed": "Frame did not load",
      "frame_missing": "Frame not found",
      "frame_retry": "Retry",
      "mark_failed": "Could not mark the event",
      "mark_false": "False alarm",
      "marked": "Event marked as a false alarm",
      "marked_by": "Marked as false by {{user}}",
      "next_frame": "Next frame",
      "no_frames": "No frames were saved for this event",
      "no_media": "You have no access to frames",
      "people": "People",
      "previous_frame": "Previous frame",
      "started": "Started",
      "store": "Store",
      "zone": "Zone",
      "cameras": "Cameras"
    },
    "time_span_open": "{{start}} – now",
    "whole_store": "Whole store"
  },
  "grouped": {
    "legend": "Colours",
    "period_presets": "Quick period",
    "preset_last_month": "Last month",
    "preset_month": "Month",
    "preset_week": "Week",
    "show_more": "Show more ({{left}})",
    "show_more_groups_one": "{{count}} more store",
    "show_more_groups_other": "{{count}} more stores"
  },
  "trading_hours_page": {
    "after_midnight_hint": "(+1) — after midnight, on the next calendar date",
    "calendar_aria": "Calendar of day statuses",
    "card_average_close": "Average closing",
    "card_average_open": "Average opening",
    "card_early_days": "Days closed early",
    "card_late_days": "Days opened late",
    "card_measured_hint": "Only stores with a shutter camera",
    "card_stores": "Stores",
    "card_stores_hint": "{{days}} working days",
    "closed_day": "did not open",
    "column_average_close": "Avg. closing",
    "column_average_open": "Avg. opening",
    "column_closed": "Closed",
    "column_date": "Date",
    "column_deviation": "Deviation",
    "column_early_days": "Closed early",
    "column_hours": "Worked",
    "column_late_days": "Opened late",
    "column_opened": "Opened",
    "column_openings": "Openings while closed",
    "column_plan": "Plan",
    "column_source": "Source",
    "column_store": "Store",
    "column_total_hours": "Total hours",
    "column_worked_days": "Working days",
    "daily_title": "Daily working hours",
    "days_value_one": "{{count}} day",
    "days_value_other": "{{count}} days",
    "deviation_value": "{{minutes}} min",
    "download_csv": "Download (CSV)",
    "download_csv_hint": "Every day of the period, every store",
    "expand_store": "{{store}}: show days",
    "filter_all": "All",
    "filter_label": "Show",
    "filter_longer": "Longer",
    "filter_minutes_label": "Longer than how many minutes",
    "filter_minutes_option": "longer than {{minutes}} min",
    "filter_night": "Only at night",
    "kind_cleaning": "Cleaning",
    "kind_night": "Night opening",
    "latest": "latest {{date}}",
    "minutes": "{{minutes}} min",
    "next_page": "Next",
    "no_rows": "No data for this period",
    "openings_info": "The shutter was opened for a short time (under 2 hours) while the store was closed: usually cleaning or a delivery. Openings at night (00:00–06:00) are marked separately. Only stores with a shutter camera.",
    "openings_list": "Openings by store",
    "openings_none": "No openings while closed in this period",
    "openings_none_filtered": "No openings match the chosen filter",
    "openings_summary": "{{stores}} stores · {{openings}} openings · longest {{longest}}",
    "openings_title": "Openings while closed",
    "page_status": "{{from}}–{{to}} of {{total}} stores",
    "per_schedule": "per schedule",
    "previous_page": "Previous",
    "status_closed": "Did not open",
    "status_late": "Opened late / closed early",
    "status_no_data": "No data",
    "status_on_time": "On time",
    "status_per_schedule": "Per schedule (no shutter camera)",
    "summary_aria": "Period at a glance",
    "times_one": "{{count}} time",
    "times_other": "{{count}} times",
    "total_hours_value": "{{hours}} h",
    "view_calendar": "Calendar",
    "view_label": "View",
    "view_table": "By store"
  },
  "marketing": {
    "billz": {
      "title": "Billz",
      "token": "Billz secret token",
      "connect": "Connect",
      "stores_hint": "Choose the Billz shop for each store. Sales are read as daily totals.",
      "no_shop": "Not linked",
      "save": "Save and import",
      "importing": "Importing the last 90 days of sales",
      "error": "The last read failed; it retries next hour.",
      "disconnect": "Disconnect",
      "disconnect_title": "Disconnect Billz?",
      "disconnect_text": "New sales stop being read. Sales already read stay.",
      "status_on": "On",
      "status_stores": "Choose stores",
      "status_error": "Error"
    },
    "period_label": "Period",
    "money": "{{value}} UZS",
    "pager": "{{first}}–{{last}} of {{total}}",
    "pager_previous": "Previous page",
    "pager_next": "Next page",
    "errors": {
      "not_available": "This is not available yet.",
      "not_linked": "This Instagram account is not linked to the messaging service.",
      "bot_unavailable": "Could not reach the messaging service. Please try again shortly.",
      "bot_error": "The messaging service did not complete the request. Please try again shortly.",
      "center_unavailable": "Could not get visit data. Please try again shortly.",
      "reply_window_closed": "The reply window has closed. You can reply once the customer writes again.",
      "instagram_send_failed": "Instagram did not accept the message. Please try again.",
      "stop_failed": "Could not stop the automations, so the account stays connected. Please try again shortly.",
      "erase_failed": "Could not delete the data, so the account stays connected. Please try again shortly.",
      "shared_automations": "Some of this account's automations also answer on another account of the same owner. Switch them off under Automation, then try again.",
      "shared_data": "Part of this account's data is shared with another account of the same owner. To delete it, write to support@topkey.uz.",
      "connected_elsewhere": "This account is also connected to another company. To delete its data, write to support@topkey.uz."
    },
    "answer": {
      "estimate": "Estimate: not compared with another store, so the season may also affect it.",
      "question": "Did marketing make money?",
      "no_spend": "No spend was entered, so the profit is not complete.",
      "profit": {
        "title": "Yes, {{profit}} profit",
        "detail": "Extra sales {{sales}}, spend {{spend}}.",
        "action": "Campaigns"
      },
      "loss": {
        "title": "No, {{profit}} loss",
        "detail": "Extra sales {{sales}}, spend {{spend}}.",
        "action": "Campaigns"
      },
      "need_margin": {
        "title": "Extra sales: {{sales}}",
        "detail": "Enter your margin to see the profit.",
        "action": "Enter margin"
      },
      "need_sales": {
        "title": "Visits went up: +{{visits}}",
        "detail": "Upload the sales of the campaign days to see the profit.",
        "action": "Upload sales"
      },
      "unclear": {
        "title": "Not clear yet",
        "detail": "Extra visits between {{low}} and {{high}}: the increase is not confirmed yet.",
        "action": "Campaigns"
      },
      "down": {
        "title": "No, visits did not go up",
        "detail": "The advertised stores fell behind the control store.",
        "action": "Campaigns"
      },
      "waiting": {
        "title": "Waiting for the result",
        "detail": "Once the campaign starts it is compared with the days before.",
        "action": "Campaigns"
      },
      "no_control": {
        "title": "Cannot be calculated",
        "detail": "The campaign has no control store. Choose one in a new campaign.",
        "action": "Add a campaign"
      },
      "one_store": {
        "title": "Not enough data for a result yet",
        "detail": "Needs at least 2 weeks of visits before the campaign. Visits and sales are below.",
        "action": "Campaigns"
      },
      "period_empty": {
        "title": "No campaigns in this period",
        "detail": "Choose another period or add a new campaign.",
        "action": "Campaigns"
      }
    },
    "overview": {
      "title": "Result",
      "full_report": "All metrics",
      "spend": "Ad spend",
      "extra_visits": "Extra visits",
      "range": "Range: {{low}} … {{high}}",
      "visit_cost": "Cost per visit",
      "buyer_cost": "Cost per customer",
      "chart_title": "Daily trend",
      "funnel_title": "From view to purchase",
      "measured_spend": "With a measured result: {{value}}"
    },
    "verdict": {
      "up": "Visits went up",
      "down": "Visits went down",
      "unclear": "Not clear"
    },
    "leak": {
      "content": {
        "title": "The content or the offer is not drawing interest",
        "action": "Try a different offer and content."
      },
      "reply": {
        "title": "People are interested but not coming",
        "action": "Reply faster and add the address and a promo code."
      },
      "store": {
        "title": "Visits rose but sales did not",
        "action": "The problem is inside the store: check staff, prices and range."
      },
      "margin": {
        "title": "Sales rose but profit did not",
        "action": "Review the discount and the ad budget."
      },
      "none": {
        "title": "The advertising is profitable",
        "action": "Keep going and watch how many customers return."
      },
      "not_enough_data": {
        "title": "Not enough data for a conclusion",
        "action": "Finish the steps above and the conclusion will appear."
      }
    },
    "factor": {
      "conversion": "Conversion",
      "average_check": "Average receipt",
      "returning": "Returning customers",
      "local_reach": "Local reach",
      "reply": "Reply speed",
      "quiet_hours": "Quiet hours"
    },
    "campaigns": {
      "title": "Campaigns",
      "new_title": "New campaign",
      "edit_title": "Edit campaign",
      "edit": "Edit",
      "edit_named": "Edit: {{name}}",
      "name": "Name",
      "offer": "Offer",
      "stores": "Advertised stores",
      "control_stores": "Control store",
      "control_hint": "A similar store without the ads. The difference shows what the ads did.",
      "single_store_hint": "Measuring profit needs a second store to compare with.",
      "choose_stores": "Choose stores",
      "overlap_error": "A store cannot be in both lists.",
      "from": "Start",
      "to": "End",
      "dates_error": "The end cannot be before the start.",
      "radius": "Ad radius, km",
      "save": "Save campaign",
      "created": "Campaign saved",
      "status": "Status",
      "period": "Period",
      "result": "Result",
      "result_no_control": "No control store",
      "result_not_started": "Not started yet",
      "result_waiting": "Waiting for the result",
      "empty": "No campaigns yet",
      "empty_hint": "Profit is calculated through campaigns.",
      "add": "Add a campaign",
      "delete": "Delete",
      "delete_title": "Delete the campaign?",
      "delete_description": "The campaign \"{{name}}\" will be removed from the list.",
      "details": "Campaign",
      "spend": "Ad spend, UZS"
    },
    "campaign_status": {
      "planned": "Planned",
      "running": "Running",
      "finished": "Finished"
    },
    "content": {
      "title": "Content",
      "empty_title": "Instagram is not connected yet",
      "syncing_title": "Instagram is connected, posts have not arrived yet",
      "syncing_hint": "The first load takes a few minutes.",
      "refresh": "Refresh",
      "caption": "Content",
      "kind": "Type",
      "published": "Date",
      "views": "Views",
      "reach": "Reach",
      "saves": "Saves",
      "comments": "Comments",
      "direct_messages": "Messages",
      "view": "View",
      "view_grid": "Grid",
      "view_table": "Table"
    },
    "content_kind": {
      "reel": "Reel",
      "post": "Post",
      "story": "Story"
    },
    "ads": {
      "title": "Advertising",
      "not_ready_title": "The ad account is not available yet",
      "not_ready_hint": "For now, enter ad spend on the campaign.",
      "to_campaigns": "Go to campaigns",
      "name": "Campaign",
      "status": "Status",
      "spend": "Spend",
      "reach": "Reach",
      "clicks": "Clicks",
      "local_reach": "Local reach"
    },
    "ad_status": {
      "active": "Active",
      "paused": "Paused",
      "ended": "Ended"
    },
    "automation": {
      "title": "Automation",
      "empty_title": "This account is not connected to automation",
      "name": "Automation",
      "keywords": "Keywords",
      "comments": "Comments",
      "direct_messages": "Messages sent",
      "saved": "Saved",
      "failed": "Failed",
      "match": "Match",
      "match_contains": "Contains",
      "match_exact": "Exact",
      "match_starts_with": "Starts with",
      "posts": "Posts",
      "all_posts": "All posts",
      "message": "Message text",
      "followup": "Follow-up message",
      "delete": "Delete",
      "save": "Save",
      "delete_title": "Delete this automation?",
      "empty": "No automations yet",
      "new_title": "New automation",
      "triggers": "Runs on",
      "trigger_comment": "Comment",
      "trigger_dm": "Message",
      "trigger_story_reply": "Story reply",
      "trigger_story_mention": "Story mention",
      "edit": "Edit",
      "actions": "Actions: {{name}}",
      "not_found": "Automation not found",
      "wizard": {
        "exit": "Exit",
        "back": "Back",
        "next": "Next",
        "create": "Create",
        "preview": "Preview",
        "step_of": "Step {{current}} of {{total}}",
        "step_trigger": "Trigger",
        "step_message": "Message",
        "step_extras": "Extras",
        "leave_title": "Leave without saving?",
        "leave_text": "Your changes will be lost.",
        "leave_confirm": "Leave",
        "templates_title": "What should it do?",
        "templates": {
          "comment_link": {
            "title": "Comment to message with link",
            "description": "A comment gets a message; followers get the link.",
            "keywords": "link",
            "message": "Hi! Follow our account, then tap the button below and we will send you the link.",
            "button": "I followed",
            "followup": "Thank you! Here is the link: https://",
            "replies": "Sent you a message!|Check your messages|We replied by message"
          },
          "price": {
            "title": "Price answer",
            "description": "Someone asks the price, the answer comes at once.",
            "keywords": "price|how much|cost",
            "message": "Hi! Which product are you interested in? Send us a photo and we will tell you the price.",
            "replies": "We replied by message|Check your messages"
          },
          "story": {
            "title": "Story reply",
            "description": "Answers people who reply to your story.",
            "keywords": "want|interested",
            "message": "Thanks for your reply! If you have a question, write it here."
          },
          "blank": {
            "title": "Blank",
            "description": "Start from an empty form."
          }
        },
        "trigger_text_comment": "Someone comments on a post or reel",
        "trigger_text_dm": "Someone writes to your direct messages",
        "trigger_text_story_reply": "Someone replies to your story",
        "trigger_text_story_mention": "Someone mentions you in a story; no keyword needed",
        "posts_specific": "Specific posts",
        "posts_empty": "No posts found on this account",
        "posts_selected": "Selected: {{count}}",
        "post_number": "Post {{number}}",
        "keywords_hint": "Press Enter after each word.",
        "keywords_placeholder": "price",
        "message_placeholder": "Hi! Here is what you asked for...",
        "button_title": "Button and next message",
        "button_text": "A tap checks that they follow you, then sends the next message.",
        "button_text_mixed": "A tap checks that they follow you, then sends the next message. Works only in the reply to a comment.",
        "button_label": "Button text",
        "button_default": "I followed",
        "followup_placeholder": "Thank you! Here it is...",
        "replies_title": "Public replies to comments",
        "replies_text": "One is picked at random for each comment.",
        "replies_default": "Sent you a message!|Check your messages|We replied by message",
        "reply_number": "Reply {{number}}",
        "reply_remove": "Remove reply {{number}}",
        "reply_add": "Add reply",
        "reminder_title": "Own reminder to follow",
        "reminder_text": "Sent when someone taps the button without following. Off: the standard text.",
        "reminder_label": "Reminder text",
        "reminder_default": "Please follow our account first, then tap the button again.",
        "active_title": "Turn on at once",
        "active_text": "Off: saved, but does not reply until you switch it on.",
        "error_need_trigger": "Choose at least one trigger",
        "error_need_post": "Choose at least one post",
        "error_need_keyword": "Add a keyword",
        "error_need_message": "Write the message",
        "error_too_long": "The text is too long",
        "error_need_link": "Finish the link after https://",
        "error_need_button": "Write the button text",
        "error_need_followup": "Write the next message",
        "error_need_reply": "Write at least one reply",
        "error_need_reminder": "Write the reminder",
        "preview_tab_message": "Message",
        "preview_tab_comment": "Comment",
        "preview_account": "your_account",
        "preview_user": "customer",
        "preview_keyword": "keyword",
        "preview_comment_note": "Reply to your comment: {{keyword}}",
        "preview_story_reply": "Replied to the story",
        "preview_story_mention": "Mentioned you in a story",
        "preview_input": "Message...",
        "preview_comments": "Comments",
        "preview_random": "One of {{count}}, at random"
      }
    },
    "sales": {
      "title": "Sales",
      "format_hint": "Each line: date, store name, sales amount, number of receipts. Open the sample, fill in the amounts and upload it.",
      "file_hint": "CSV files only",
      "file_errors": "{{count}} errors in the file, nothing was uploaded:",
      "more_errors": "{{count}} more errors.",
      "store_names": "Names in the panel: {{names}}",
      "empty_file": "The file has no sales rows",
      "unreadable_file": "The file could not be read. Check that it is a CSV.",
      "imported": "{{count}} rows uploaded",
      "imported_dates": "Dates: {{from}} – {{to}}",
      "error": {
        "columns": "Line {{line}}: 4 columns are required",
        "date": "Line {{line}}: invalid date ({{value}}). Example: 2026-11-04",
        "store": "Line {{line}}: store not found ({{value}})",
        "revenue": "Line {{line}}: sales amount is missing or invalid ({{value}})",
        "receipts": "Line {{line}}: receipt count is missing or invalid ({{value}})",
        "duplicate": "Line {{line}}: this day and store appear twice ({{value}})"
      },
      "margin": "Margin, %",
      "margin_hint": "How much profit is left from every 100 UZS of sales.",
      "save": "Save",
      "margin_saved": "Margin saved",
      "date": "Date",
      "store": "Store",
      "revenue": "Sales",
      "receipts": "Receipts",
      "empty": "No sales data for this period",
      "empty_hint": "Upload a file of daily sales and receipts.",
      "upload": "Upload",
      "upload_title": "Upload a sales file",
      "sample": "Download a sample file",
      "total": "Total sales",
      "average_check": "Average receipt",
      "all_stores": "All stores",
      "margin_value": "Margin: {{value}}%",
      "margin_empty": "Enter margin"
    },
    "connections": {
      "title": "Connections",
      "connected": "Connected",
      "not_connected": "Not connected",
      "disconnect": "Disconnect",
      "disconnect_title": "Disconnect and stop automations?",
      "disconnect_instagram_description": "{{name}} and its posts leave this panel, and all its automations stop answering. Its conversation history is kept. Connecting it again does not turn them back on: you switch them on yourself.",
      "disconnect_stop": "Disconnect and stop",
      "reconnect_needed": "Reconnect needed",
      "reconnect": "Reconnect",
      "erase": "Delete data",
      "erase_title": "Delete all of this account's data?",
      "erase_description": "All messages, logs, comments, automations and tokens of {{name}} are deleted from the messaging service, and its connection and posts from this panel. This cannot be undone.",
      "erase_confirm": "Delete everything",
      "erased": "The account's data has been deleted",
      "automation_not_linked": "Automation not linked",
      "instagram": {
        "title": "Instagram"
      },
      "sales": {},
      "connect": "Connect",
      "sales_label": "Sales file (CSV)",
      "open": "Open",
      "return": {
        "connected": "Instagram connected",
        "cancelled": "Connection cancelled",
        "expired": "Timed out, try again",
        "failed": "Could not connect"
      }
    },
    "accounts": {
      "switch": "Instagram account: {{name}}",
      "none": "No account",
      "connect_new": "Connect new account",
      "reconnect": "Reconnect {{name}}"
    },
    "period_days": "{{count}} days",
    "seconds": "{{count}} s",
    "new": "New",
    "all": "All",
    "setup": {
      "title": "Steps left to see your profit: {{count}}",
      "instagram": {
        "title": "Connect Instagram",
        "hint": "Comments and messages arrive here"
      },
      "automation": {
        "title": "Turn on automation",
        "hint": "People who comment get a message automatically"
      },
      "campaign": {
        "title": "Add your first campaign",
        "hint": "With a control store: that is how profit is calculated",
        "hint_single_store": "Dates, offer and ad spend"
      },
      "sales": {
        "title": "Upload a sales file",
        "hint": "Daily sales and receipt counts"
      },
      "margin": {
        "title": "Enter your margin",
        "hint": "How much profit is left from every 100 UZS of sales"
      }
    },
    "metric": {
      "spend": "Spend",
      "visits": "Visits",
      "sales": "Sales"
    },
    "funnel": {
      "views": "Views",
      "direct_messages": "Messages",
      "extra_visits": "Extra visits",
      "buyers": "Buyers"
    },
    "money_million": "{{value}}M UZS",
    "chats": {
      "title": "Chats",
      "search": "Search",
      "kind_conversations": "Conversations",
      "kind_all": "All",
      "empty": "No conversations yet",
      "empty_all": "Nobody has commented or written yet",
      "empty_action": "Turn on automation",
      "not_found": "Nobody found",
      "clear_search": "Clear search",
      "load_more": "Show more",
      "choose": "Choose a conversation",
      "back": "Back",
      "unknown_person": "Instagram user",
      "no_messages": "No messages yet",
      "placeholder": "Write a reply",
      "send": "Send",
      "window_closed_title": "You cannot reply right now",
      "window_closed_hint": "Instagram allows replies for 24 hours after the last message. You can reply once the customer writes again.",
      "comment_only_title": "This person only commented",
      "comment_only_hint": "Instagram does not allow writing first. You can reply once they send a message.",
      "open_instagram": "Open in Instagram",
      "delete_data": "Delete this person's data",
      "delete_data_title": "Delete this person's data?",
      "delete_data_description": "Their messages, comments and logs on this account and their tags are deleted. This cannot be undone. If they write or comment again, the new messages are recorded.",
      "delete_data_confirm": "Delete",
      "delete_data_done": "This person's data has been deleted",
      "comment": "Comment",
      "tags": "Tags",
      "not_linked": "Instagram is not connected yet",
      "service_off_title": "The messaging service is not on yet",
      "service_off_hint": "Instagram is connected. Conversations appear here once the service is on."
    },
    "contacts": {
      "title": "Contacts",
      "name": "Contact",
      "total": "Total: {{count}}",
      "comments": "Comments",
      "messages": "Messages",
      "last": "Last activity",
      "reply": "Reply",
      "tags": "Tags",
      "empty": "No contacts yet",
      "can_reply": "Can reply"
    },
    "report": {
      "title": "Report",
      "metric": "Metric",
      "value": "Value",
      "next": "Status",
      "ready": "Ready",
      "cities": "Store cities",
      "metric_profit": "Extra profit",
      "metric_cost_per_customer": "Cost per customer",
      "metric_conversion": "Conversion",
      "metric_returning": "Returning customers",
      "metric_local_reach": "Local reach",
      "metric_offer": "Best offer",
      "metric_reply_speed": "Reply speed",
      "metric_timing": "Quiet hours",
      "step_campaign": "Add a campaign",
      "step_control": "Choose a control store",
      "step_one_store": "Needs 2 weeks of visits",
      "step_sales": "Upload sales",
      "step_margin": "Enter your margin",
      "step_unconfirmed": "Increase not confirmed",
      "step_cities": "Choose a city",
      "step_instagram": "Connect Instagram",
      "step_automation": "Turn on automation",
      "step_visits": "No visit data"
    }
  }
}
